export default [

     {
          path: '/risk-source',
          name: 'RiskSource',
          component: () => import("@/views/Page/RiskSource/RiskSource.vue"),
           meta: {
               title: 'RiskSource',
          },
     }
];